<!--
 * @Author: liushengjiang 1947448287@qq.com
 * @Date: 2021-12-28 15:26:11
 * @LastEditors: liushengjiang 1947448287@qq.com
 * @LastEditTime: 2023-12-18 14:44:40
 * @FilePath: \petro-web-chemicals-buyerc:\Users\Administrator\Desktop\买家app\petro-app-chemicals-buyer\src\views\login\components\Field.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="field-container">
    <van-tabs v-model="active" animated @change="tagsChange"
              :class="active ? 'content-left__radius' : 'content-right__radius'">
      <van-tab>
        <template #title>
          <div class="field-tab__title"
               :class="active ? 'field-tab__inactive' : 'field-tab__active'">
            验证码登录
          </div>
        </template>
        <template #default>
          <div class="field-content__body">
            <van-field
                v-model="phoneform.mobile"
                type="tel"
                name="mobile"
                placeholder="请输入手机号"
                border
                :rules="[{ required: true, message: '请输入手机号' }]"/>
            <van-field
                v-model="phoneform.smsCode"
                type="digit"
                name="smsCode"
                placeholder="请输入验证码"
                :rules="[{ required: true, message: '请输入验证码' }]"
            >
              <template #button>
                <van-button type="default" class="field-msg__btn"
                            @click="sendSmsCode">
                  {{ senMess }}
                </van-button>
              </template>
            </van-field>
            <div class="bottom-agree">
              <van-checkbox v-model="readChecked">已阅读并同意</van-checkbox>
              <router-link class="visitor-link" to="/userAgreement?id=01">《服务协议》</router-link>
              <router-link class="visitor-link" to="/userAgreement?id=07">《隐私政策》</router-link>
            </div>
          </div>

          <div class="btn-wrap">
            <van-button
                class="confirm-btn"
                :disabled="submitDisabled"
                @click="submitLogin">
              登录
            </van-button>
          </div>
        </template>
      </van-tab>
      <van-tab>
        <template #title>
          <div class="field-tab__title"
               :class="active ? 'field-tab__active' : 'field-tab__inactive'">
            账户登录
          </div>
        </template>
        <template #default>
          <div class="field-content__body">
            <van-form>
              <van-field
                  v-model="accountform.accountName"
                  name="accountName"
                  placeholder="请输入账号"
                  border/>
              <!-- :type="showPassword ? 'text' : 'password'" -->
              <van-field
                  v-model="accountform.loginPwd"
                  name="loginPwd"
                  type="password"
                  placeholder="请输入密码"/>
            </van-form>
            <div class="field-body__password">
              <van-checkbox v-model="checked">记住密码</van-checkbox>
              <van-button type="default"
                          @click="forgetPassword">
                忘记密码
              </van-button>
            </div>
            <div class="bottom-agree">
              <van-checkbox v-model="readChecked">已阅读并同意</van-checkbox>
              <router-link class="visitor-link" to="/userAgreement?id=01">《服务协议》</router-link>
              <router-link class="visitor-link" to="/userAgreement?id=07">《隐私政策》</router-link>
            </div>
          </div>
          <div class="btn-wrap">
            <van-button
                class="confirm-btn"
                :disabled="submitDisabled"
                @click="submitLogin">
              登录
            </van-button>
          </div>
        </template>
      </van-tab>
    </van-tabs>
    <div class="white-block"></div>
    <van-dialog
        class="app-version_dialog"
        v-model="show" title=""
        show-cancel-button
        confirmButtonText="立即升级"
        confirmButtonColor="#b3d2ef"
        cancelButtonColor="black"
    >
      <div>
        <div class="tabFirst">
          <div class="imgsTwo">
            <img src="@/assets/imgs/火箭.png" alt="">
            <h2>发现新版本</h2>
            <h5>{{ versionName }}</h5>
          </div>
          <div class="info" @click="show = false" v-show="!forceUpdate">
            <img src="@/assets/imgs/关闭.png" alt="">
          </div>
        </div>
        <div class="tabTwo">
          <!-- <h2>更新内容：</h2> -->
          <ul>
            <li v-for="(item,index) of description" :key="index">{{ item }}</li>
          </ul>
        </div>
        <div class="tabThree">
          <!-- <van-button class="confirm-btns" @click="confirmChange" v-if="btnShow==='1'">downFile调用</van-button> -->
          <van-button
              class="confirm-btns"
              @click="confirmChanges"
              v-if="btnShow==='1'">立即升级
          </van-button>
          <van-button class="confirm-btntwo" v-if="btnShow==='2'">{{ status }}</van-button>
          <van-progress color="#e62911" :percentage="percentage" v-if="btnShow==='3'"/>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
// eslint-disable-next-line no-irregular-whitespace
import SHA256 from "@/common/js/SHA256";
import accountApi from "@/request/accountApi";
import {setStore, getStore} from "@/store/storage.js";
import {loginSources, getVersion, getloadFile} from "@/request/flutterBrid";

export default {
  name: "Field",
  props: {
    showAccount: Boolean,
  },
  data() {
    return {
      active: 0,
      checked: false,
      showPassword: false,
      readChecked: false,
      forceUpdate: false,
      percentage: 0, // 进度条百分比
      params: '',
      show: false, //弹窗展示
      btnShow: '1',
      downloadProgress: null,
      versionName: "v1.0.0",
      status: '下载中',
      description: [],
      beforeUrl: '',
      imgUrl:
          this.$common.interfacePath.serverTestUrl +
          "/account/getVerificationCode",
      eyePath: require("@/assets/imgs/eye-close.png"),
      phoneform: {
        mobile: "",
        smsCode: "",
      },
      accountform: {
        accountName: "",
        loginPwd: "",
        // validCode: "",
        uid: "",
      },
      smsCode: "",
      countdown: 60,
      disabledFlag: false,
      senMess: "发送验证码",
      phoneTabStyle: {
        color: 'rgba(0, 0, 0, 0.42)',
        fontSize: '28px',
        textAlign: 'center',
        fontFamily: 'AlibabaPuHuiTi_2_85_Bold',
        height: '106px'
      }
    };
  },
  computed: {
    submitDisabled() {
      if (this.active) {
        return (
            this.$utils.isEmpty(this.accountform.accountName) ||
            this.$utils.isEmpty(this.accountform.loginPwd)
        );
      } else {
        return (
            this.$utils.isEmpty(this.phoneform.mobile) ||
            this.$utils.isEmpty(this.phoneform.smsCode)
        );
      }
    },
  },
  created() {
    let checked = Boolean(localStorage.getItem("checked"));
    if (checked) {
      this.checked = true;
    }
  },
  mounted() {
    console.log(getStore("accountName"));
    console.log(getStore("mobilePhone"));
    this.accountform.accountName = localStorage.getItem("accountNameBuyer");
    if (this.checked) {
      this.accountform.loginPwd = localStorage.getItem("password");
    } else {
      this.passwordBefore = "";
    }
    getVersion((result) => {
      console.log("调取设备信息55555", result);
      this.params = JSON.parse(result);
      console.log("设备返回版本666", this.params);
      console.log("每个数据", this.params.versionCode, this.params.versionName, this.params.packageName);
      this.getList()
    });

    // this.phoneform.mobile = getStore("mobilePhone");
    this.imgChange();
  },
  methods: {
    tagsChange(){
      this.$emit('switchLoginType', !!this.active)
    },
    confirmChanges() {
      this.confirmChangeTwo();
    },
    confirmChangeTwo() {
      this.btnShow = '3'
      getloadFile(this.url,
          (result) => {
            console.log('downloadFile调用', result);
            let data = JSON.parse(result);
            console.log('downloadFile返回单个数据', data.downloadStatus, data.downloadProgress);
            this.percentage = data.downloadProgress;
            if (data.downloadStatus === 'OtaStatus.INSTALLING') {
              this.status = '下载成功';
              this.btnShow = '2'
            }
            if (data.downloadStatus === 'OtaStatus.DOWNLOAD_ERROR') {
              this.status = '下载失败';
              this.btnShow = '2'
            }
          });
    },
    async getList() {
      let params = {
        versionName: this.params.versionName || '1.0.0',
        versionCode: this.params.versionCode || 1,
        packageName: this.params.packageName || 'com.chemicals.buyer',
      };
      let data = await accountApi.newAppVersion(params);
      console.log(2222, data);
      if (data.returnCode === "0") {
        console.log('接口返回url地址', data.result);
        if (data.result) {
          if (data.result.versionCode > this.params.versionCode || this.params == 22222) {
            this.show = true
          }
          this.url = data.result.downUrl;
          this.forceUpdate = data.result.forceUpdate;
          this.description = data.result.description.split('\r\n');
          console.log(2222, this.description);
          this.versionName = 'v' + data.result.versionName;
          console.log(88888, this.url);
        }
      } else {
        this.$toast({
          type: "fail",
          message: data.returnMessage,
          duration: 1500,
        });
      }
    },
    handleEyeClick() {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        this.eyePath = require("@/assets/imgs/eye-open.png");
      } else {
        this.eyePath = require("@/assets/imgs/eye-close.png");
      }
    },
    // imgChange() {
    //   var timestamp = new Date().getTime();
    //   this.imgUrl =
    //     this.$common.interfacePath.serverTestUrl +
    //     "/account/getVerificationCode?" +
    //     timestamp;
    // },
    imgChange() {
      function guid() {
        function S4() {
          return (((1 + Math.random()) * 0x10000) | 0)
              .toString(10)
              .substring(1);
        }

        return S4() + S4() + S4() + S4() + S4() + S4() + S4();
      }

      this.accountform.uid = guid();
      this.imgUrl =
          this.$common.interfacePath.serverTestUrl +
          "/account/getVerificationCode?uid=" +
          this.accountform.uid;
    },
    sendSmsCode() {
      if (this.disabledFlag) {
        return;
      }
      if (!this.phoneform.mobile) {
        this.$toast({
          type: "fail",
          message: "请输入手机号",
          duration: 1500,
        });
        return;
      }
      if (!this.$utils.isPhone(this.phoneform.mobile)) {
        this.$toast({
          type: "fail",
          message: "请输入正确的手机号",
          duration: 1500,
        });
        return;
      }
      let params = {
        mobile: this.phoneform.mobile,
      };
      accountApi.sendLoginSms(params).then((res) => {
        if (res.returnCode == "0") {
          this.settime();
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    settime() {
      if (this.countdown === 0) {
        this.senMess = "发送验证码";
        this.countdown = 60;
        this.disabledFlag = false;
        return false;
      } else {
        this.disabledFlag = true;
        this.senMess = this.countdown + "s";
        this.countdown--;
      }
      let _this = this;
      setTimeout(() => {
        _this.settime();
      }, 1000);
    },
    forgetPassword() {
      this.$router.push("/resetPassword");
    },
    async submitLogin() {
      let callback = (result) => {
        let token = result.token;
        let userInfo = result.userInfo;
        setStore("token", token);
        setStore("userInfo", userInfo);
        let accountName = this.accountform.accountName;
        localStorage.setItem("accountNameBuyer", accountName);
        let passwordBefore = this.accountform.loginPwd;
        localStorage.setItem("password", passwordBefore);
        let checked = this.checked ? 100 : "";
        localStorage.setItem("checked", checked);
        if (this.showAccount) {
          setStore("accountName", userInfo.accountName);
        } else {
          setStore("mobilePhone", userInfo.mobilePhone);
        }
        this.$store.commit("setToken", token);
        this.$store.commit("setUserInfo", userInfo);
        loginSources((result) => {
          console.log("买家登陆", result);
        });
        // this.$router.push("/Home");
      };
      if (!this.readChecked) {
        this.$toast({
          type: "fail",
          message: "请勾选已阅读同意中油e化隐私协议和中油e化用户协议",
          duration: 1500,
        })
        return
      }
      let params = {};
      if (this.showAccount) {
        params.accountName = this.accountform.accountName;
        params.loginPwd = SHA256(this.accountform.loginPwd);
        // params.validCode = this.accountform.validCode;
        params.uid = this.accountform.uid;
        // params.bizLine ="03";
        accountApi.loginApp(params).then((res) => {
          if (res.returnCode == "0") {
            let result = res.result;
            callback(result);
            if (result.userInfo.defaultPwd == "1") {
              this.$toast({
                type: "fail",
                message: "首次登陆，请修改密码,不小于8位的英文字母大小写及数字",
                duration: 1500,
              });
              setTimeout(() => {
                this.$router.push({
                  path: "/updatePassword",
                });
              }, 1500);
            } else {
              // callback(result);
              this.$router.push("/Home");
            }
          } else {
            this.$toast({
              type: "fail",
              message: res.returnMessage,
              duration: 1500,
            });
          }
        });
      } else {
        params = Object.assign({}, this.phoneform);
        accountApi.smsLogin(params).then((res) => {
          if (res.returnCode == "0") {
            let result = res.result;
            callback(result);
            this.$router.push("/Home");
          } else {
            this.$toast({
              type: "fail",
              message: res.result,
              duration: 1500,
            });
          }
        });
      }
    },
    goSystem(system) {
      if (system === "seller") {
        // window.location.href =
        //   "https://sell.chem.petrochina.com.cn/chemicals_sale_app/#/login";
        //   window.location.href =
        // "http://106.37.238.69/chemicals_sale_app/#/login";
        console.log(location.hostname);
        if (
            location.hostname != "localhost" &&
            location.hostname != "11.8.238.156" &&
            location.hostname != "106.37.238.69"
        ) {
          window.location.href =
              "https://sell.chem.petrochina.com.cn/chemicals_sale_app/#/login"; //生产
        } else {
          window.location.href =
              "http://106.37.238.69/chemicals_sale_app/#/login"; //测试
        }
      }
      // } else if (system === "logistics") {
      //   window.location.href =
      //     "https://lmsapp.chem.petrochina.com.cn:8083/";
      // }
      window.open();
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl';

.field-container {
  position: relative;
  padding: 64px 28px 0 28px;
  height: calc(100% - 215px);
  letter-spacing 3px

  input {
    letter-spacing 3px
  }

  span {
    letter-spacing 3px
  }

  /deep/ .van-dialog {
    background: url('../../../assets/imgs/背景.png');
    background-size: cover;
    overflow: visible;
    width: 6.7rem;
    border-radius: 0.5rem;
  }

  /deep/ .van-hairline--top {
    display: none !important;
  }

  /deep/ .van-tabs {
    border-radius 40px 40px 0 0 !important
    background-color rgba(248, 247, 250, 1) !important
    height 100%
  }

  /deep/ .van-tab {
    padding 0 !important
  }

  /deep/ .van-tabs__wrap {
    height 106px !important
    border-radius 40px 40px 0 0
  }

  /deep/ .van-tabs__nav {
    background-color rgba(1, 1, 1, 0) !important
  }

  /deep/ .van-tab__text {
    width 100%
  }

  /deep/ .van-tabs__line {
    width 22px !important
    height 8px !important
    position: absolute !important
    top: 80px !important
    z-index 2 !important
  }

  .white-block {
    height 40px
    width 20%
    background-color white
    position: absolute;
    left 40%
    top 130px
    z-index 2
  }

  /deep/ .van-tabs__content {
    background-color white !important
    height calc(100% - 106px)
    min-height 600px
  }


  /deep/ .van-field {
    font-size: 30px;
    line-height: 96px;
    height: 96px;
    border-radius: 16px;
    background-color: rgba(241, 247, 250, 1);
    margin-bottom 38px

    .van-field__body {
      height 100%

      input {
        font-size: 32px;
        font-weight bold
        font-family: AlibabaPuHuiTi_2_95_ExtraBold;
      }

      input::-webkit-input-placeholder {
        font-size: 28px !important
        font-weight normal !important
        letter-spacing 3px
      }

      .field-msg__btn {
        width: 198px;
        height: 68px;
        border-radius: 16px;
        color: rgba(255, 79, 0, 1);
        font-size: 24px;
        font-weight bold
        font-family: AlibabaPuHuiTi_2_65_Medium;
      }
    }
  }
}

.field-tab__title {
  width 100%
  font-size: 28px
  text-align: center
  font-family: AlibabaPuHuiTi_2_85_Bold
  height: 106px
  display flex
  justify-content center
  align-items center
  font-weight bold
  position absolute
  top 0
}

.field-tab__active {
  color: rgba(255, 79, 0, 1);
  background-color white !important
  border-radius 40px 40px 0 0
  z-index 2
}

.field-tab__inactive {
  color: rgba(0, 0, 0, 0.42)
  border-radius 0 0 40px 40px
  background-color rgba(248, 247, 250, 1) !important
  z-index 3
}

.content-left__radius {
  /deep/ .van-tabs__content {
    border-top-left-radius 40px !important
  }
}

.content-right__radius {
  /deep/ .van-tabs__content {
    border-top-right-radius 40px !important
  }
}

.field-content__body {
  padding 64px 64px 12px 64px
  background-color white

  .field-body__password {
    width 100%
    line-height 32px
    display flex
    justify-content space-between
    font-family: PingFangSC-Semibold

    /deep/ .van-checkbox__label {
      color: rgba(176, 176, 176, 1) !important
      font-weight bold
      font-size: 22px
    }

    /deep/ .van-button {
      width: 100px;
      height: 32px;
      padding 0
      border none
      font-size: 22px
      font-weight bold
      font-family: PingFangSC-Semibold
      color: rgba(176, 176, 176, 1) !important
    }
  }

  /deep/ .van-field__body{
    border none !important
    padding 0 !important
  }
}


.btn-wrap {
  display: flex;
  justify-content: center;
  background-color white
  padding 0 64px

  .confirm-btn {
    width: 100%;
    height: 90px;
    margin-top: 14px
    border-radius: 24px;
    background: rgba(255, 79, 0, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 32px;
    font-family: PingFangSC-Semibold;
  }
}


.bottom-agree {
  width 100%
  height 40px
  //position fixed
  //bottom 14px
  //left 0
  display: flex;
  justify-content left
  align-items center
  font-size: 22px;
  font-family: PingFangSC-Semibold;

  /deep/ .van-checkbox {
    height 40px

    .van-checkbox__label {
      color: rgba(176, 176, 176, 1);
    }
  }

  /deep/ a {
    color: rgba(249, 144, 27, 1);
  }
}


.field-container >>> .van-field__left-icon {
  margin-right: 18px;
}

.field-wrap {
  padding: 0 40px;

  .field-icon {
    width: 52.47px;
    text-align: center;

    .icon-phone {
      width: 32.65px;
      height: 55.85px;
    }

    .icon-sms {
      width: 52.47px;
      height: 42.73px;
    }

    .icon-account {
      width: 40.24px;
      height: 46.91px;
    }

    .icon-password {
      width: 40px;
      // height: 54.15px;
    }
  }


}

.tabFirst {
  margin: 0.8rem 0.1rem 0.2rem 0.1rem;
  text-align: center;
  // background-color: #317fc9;
  color: white;
  position: relative;
  h2 {
    margin: 0.4rem 0 0.2rem 0;
    font-size: 0.5rem;
    color: black;
    font-weight: 550;
    letter-spacing: 0.1rem;
  }
  h5 {
    padding-bottom: 0.2rem;
    color: #999999;
    font-size: 0.4rem;
  }
  .info {
    width: 1rem;
    position: absolute;
    top: -0.5rem;
    right: -0.1rem;
    img {
      width: 0.65rem;
    }
  }
}


.tabTwo {
  padding: 0.2rem 0.3rem 0 0.3rem;
  font-size: 0.3rem;
  h2 {
    font-weight: 600;
    letter-spacing: 0.05rem;
    margin: 0 0 0.2rem 0.1rem;
  }
  li {
    margin: 0.18rem 0;
    letter-spacing: 0.02rem;
    color: #666666;
    line-height: 0.6rem;
  }
}

.tabThree {
  display: flex;
  justify-content: center;
  /deep/ .van-progress {
    width: 100%;
    height: 0.35rem;
    margin: 0.5rem 0.2rem;
    border-radius: 0.2rem;
  }
  /deep/ .van-progress__pivot {
    height: 100%;
    background: none !important;
    color: black !important;
    font-size: 0.25rem;
  }
}
.confirm-btns {
  height: 1rem;
  color: white !important;
  margin: 0.5rem 0 0.6rem 0;
  width: 6rem;
  background-color: #e62911 !important;
  border-radius: 0.5rem;
}
.confirm-btntwo {
  width: 6.5rem;
  height: 1rem;
  background-color: #e62911 !important;
  color: white !important;
  margin: 0.5rem 0 0.6rem 0;
  border-radius: 0.5rem;
}

.imgsTwo  img {
  width: 2.5rem;
  margin-top: -1.8rem;
}

  .app-version_dialog{
    top: 50vh !important;
    bottom: unset !important;
  }
</style>
